export const SUBSCRIPTION_OFFERS = 'SUBSCRIPTION_OFFERS';
export const SUBSCRIPTION_OFFERS_REQUEST = 'SUBSCRIPTION_OFFERS_REQUEST';
export const SUBSCRIPTION_OFFERS_SUCCESS = 'SUBSCRIPTION_OFFERS_SUCCESS';
export const SUBSCRIPTION_OFFERS_FAILURE = 'SUBSCRIPTION_OFFERS_FAILURE';
